import { useContext, useMemo } from "react";
import { Tooltip } from "@mui/material";
import { useChatSession } from "@/client/useChatSession";
import { GenAiContext } from "@/client/context";
import { useConfig } from "@/client/useConfig";
import Avatar from "@mui/material/Avatar";

interface Props {
  author?: string;
  hide?: boolean;
}

const MessageAvatar = ({ author, hide }: Props) => {
  const apiClient = useContext(GenAiContext);
  const { chatProfile } = useChatSession();
  const { config } = useConfig();

  const selectedChatProfile = useMemo(() => {
    return config?.chatProfiles.find((profile) => profile.name === chatProfile);
  }, [config, chatProfile]);

  const avatarUrl = useMemo(() => {
    // User avatar
    if (author === "You") {
      return "/user_avatar.svg";
    }

    // Assistant avatar
    const isAssistant = !author || author === config?.ui.name;
    if (isAssistant && selectedChatProfile?.icon) {
      return selectedChatProfile.icon;
    }

    // Default fallback
    return "/qnb_logo_lite.svg";
    // return apiClient?.buildEndpoint(`/avatars/${author || "default"}`);
  }, [apiClient, selectedChatProfile, config, author]);

  return (
    <span className="message-avatar">
      <Tooltip title={author}>
        <Avatar
          sx={{
            width: "30px",
            height: "30px",
            ...(!avatarUrl && { bgcolor: "background.paper" }),
          }}
          src={hide ? undefined : avatarUrl}
        />
      </Tooltip>
    </span>
  );
};

export { MessageAvatar };
